import React, { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import { Button, Segmented, Modal, Tag, message } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SettingOutlined,
  RightOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import { FilterOutlined } from "@ant-design/icons";
import fitericon from "../../Assets/calender/action-filter-outline.png";
import "../../App.css";
import FilterModal from "../CalenderModal/FilterModal"; // Import Filter Modal
import { URL } from "../../helper/Mainurl";
import AddTask from "../CalenderModal/AddTask";
import ViewTask from "../CalenderModal/ViewTask";
import "../Calender.css";
import ViewEvent from "../CalenderModal/ViewEvent";
import AddCoParent from "./AddCoParent";

let lastClickTime = 0;

const CoParentCalender = () => {
  const token = localStorage.getItem("authToken"); // Get token from localStorage
  const [calendarView, setCalendarView] = useState("timeGridWeek");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState([]);
  const [ViewTaskmodalOpen, setViewTaskmodalOpen] = useState(false);
  const [ViewEventmodalOpen, setViewEventmodalOpen] = useState(false);

  const [events, setEvents] = useState([]); // ✅ Store API events
  const [preselectedDate, setPreselectedDate] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [calendarApi, setCalendarApi] = useState(null);
  const calendarRef = useRef(null);
  const [calendarTitle, setCalendarTitle] = useState("");
  const [filters, setFilters] = useState({
    category: null,
    priorities: [],
    status: null,
    colors: [],
    selectedUsers: [],
  });

  // Function to handle filter application
  const applyFilters = async (newFilters) => {
    setFilters(newFilters);

    const { category, status, priorities } = newFilters;

    console.log("Applied filters::::::::::::::", newFilters);
    await getCalenderData(startDate, endDate, category, status, priorities);
  };

  const getCalenderData = async (
    startDate,
    endDate,
    category,
    status,
    priorities
  ) => {
    console.log("test", startDate, endDate);

    try {
      let queryParams = `start_date=${startDate}&end_date=${endDate}`;

      if (category) queryParams += `&type=${category}`;
      if (status) queryParams += `&progress_status_id=${status}`;
      if (priorities) queryParams += `&priority_id=${priorities}`;

      const response = await fetch(
        `${URL}/v1/calendar/calendar-data?${queryParams}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (data?.code === 200 && (!data.data || data.data.length === 0)) {
        if (category || status || priorities) {
          message.error(`No calendar data found for the selected filters.`);
        } else {
          message.error("No calendar data available for this date.");
        }
        setEvents([]); // Clear events
        return;
      }

      if (data?.code === 200 && Array.isArray(data?.data)) {
        const formattedEvents = data.data.map((event) => ({
          id: event?.event_id || event?.calendar_id || crypto.randomUUID(), // Unique fallback ID
          title: event?.title || "Untitled Event",
          location: event?.location || "No Location",
          description: event?.description || "No Description",
          start: event?.start_time
            ? moment.utc(event.start_time).format("YYYY-MM-DDTHH:mm:ss")
            : null,
          end: event?.end_time
            ? moment.utc(event.end_time).format("YYYY-MM-DDTHH:mm:ss")
            : null,
          reminder: event?.reminder_timestamp || null,
          createdBy: event?.created_by || "Unknown",
          updatedBy: event?.updated_by || "Unknown",
          type: event?.type || "event",
          displaynameId: event?.display_name_id || "Unknown",
          priorityId: event?.priority_id || null,
          progressStatusId: event?.progress_status_id || null,
          assignedBy: event?.assigned_by || "Unknown",
          checklists: Array.isArray(event?.checklists) ? event.checklists : [],
          color: event?.color || "#007bff", // Default color
        }));
        console.log("formattedEvents>>", formattedEvents);
        setEvents(formattedEvents);

        if (category || status || priorities) {
          message.success("Calendar filter applied successfully.");
        } // isFilterModalOpen(true)
      } else {
        message.error("Error fetching calendar data");
      }
    } catch (error) {
      console.error("Fetch request failed:", error);
    }
  };

  useEffect(() => {
    // if (startDate && endDate && category || status || priorities){
    //   getCalenderData(startDate, endDate,category,status,priorities);

    // }
    if (startDate && endDate) {
      getCalenderData(startDate, endDate);
    }
  }, [startDate, endDate]);

  const datesSetHandler = (info) => {
    setStartDate(moment(info.start).format("YYYY-MM-DD"));
    setEndDate(moment(info.end).format("YYYY-MM-DD"));

    const formattedTitle = info.view.title.replace(
      /(\w+) (\d+), (\d+)/,
      "$2 $1, $3"
    );
    setCalendarTitle(formattedTitle);
  };
  const handleTaskClick = (info) => {
    setViewTaskmodalOpen(true);
    const eventData = {
      id: info.event.id,
      title: info.event.title,
      location: info.event.extendedProps.location,
      description: info.event.extendedProps.description,
      start: info.event.start,
      end: info.event.end,
      displaynameId: info.event.extendedProps.displaynameId,
      reminder: info.event.extendedProps.reminder,
      createdBy: info.event.extendedProps.createdBy,
      updatedBy: info.event.extendedProps.updatedBy,
      type: info.event.extendedProps.type,
      priorityId: info.event.extendedProps.priorityId,
      progressStatusId: info.event.extendedProps.progressStatusId,
      assignedBy: info.event.extendedProps.assignedBy,
      checklists: info.event.extendedProps.checklists || [],
      color: info.event.backgroundColor,
    };

    setSelectedEvent(eventData);
    console.log("eventDataNew:::::::::", eventData);
  };
  const handleEventClick = (info) => {
    setViewEventmodalOpen(true);
    const eventData = {
      id: info.event.id,
      title: info.event.title,
      location: info.event.extendedProps.location,
      description: info.event.extendedProps.description,
      start: info.event.start,
      end: info.event.end,
      displaynameId: info.event.extendedProps.displaynameId,
      reminder: info.event.extendedProps.reminder,
      createdBy: info.event.extendedProps.createdBy,
      updatedBy: info.event.extendedProps.updatedBy,
      type: info.event.extendedProps.type,
      priorityId: info.event.extendedProps.priorityId,
      progressStatusId: info.event.extendedProps.progressStatusId,
      assignedBy: info.event.extendedProps.assignedBy,
      checklists: info.event.extendedProps.checklists || [],
      color: info.event.backgroundColor,
    };

    setSelectedEvent(eventData);
    console.log("eventDataNew:::::::::", eventData);
  };

  const handleViewChange = (value) => {
    let newView = "";
    let startDate = "";
    let endDate = "";

    const today = new Date();

    const formatDate = (date) => {
      return date.toISOString().split("T")[0]; // Returns YYYY-MM-DD
    };

    if (value === "Today") {
      newView = "timeGridDay";
      startDate = formatDate(today);
      endDate = startDate;
      getCalenderData(startDate, endDate);
    } else if (value === "Week") {
      newView = "timeGridWeek";

      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay()); // Sunday

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6); // Saturday

      startDate = formatDate(startOfWeek);
      endDate = formatDate(endOfWeek);
      getCalenderData(startDate, endDate);
    } else if (value === "Month") {
      newView = "dayGridMonth";
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      startDate = formatDate(startOfMonth);
      endDate = formatDate(endOfMonth);
      getCalenderData(startDate, endDate);
    }

    setCalendarView(newView);
    setStartDate(startDate);
    setEndDate(endDate);

    if (calendarApi) {
      calendarApi.changeView(newView);
    }
  };

  const getDayHeaderFormat = () => {
    // Apply custom formatting based on the view
    if (calendarView === "dayGridMonth") {
      return { weekday: "short" }; // Show only the weekday in Month view (e.g., "Mon")
    } else {
      return { weekday: "short", day: "numeric" }; // Show weekday and day number in Week view (e.g., "Mon 9")
    }
  };

  const showModal = (date = null) => {
    setPreselectedDate(date);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setPreselectedDate(null);
    // getCalenderData(startDate, endDate);
  };

  // const datesSetHandler = (info) => {
  //   const formattedStartDate = info.start.toISOString().split("T")[0];
  //   const formattedEndDate = info.end.toISOString().split("T")[0];

  //   setStartDate(formattedStartDate);
  //   setEndDate(formattedEndDate);
  // };
  const handleViewChangeNew = (view) => {
    setCalendarView(view);
    if (calendarApi) {
      calendarApi.changeView(view);
    }
  };
  const handlePrev = () => {
    if (calendarApi) {
      calendarApi.prev();
      updateDateRange(); // Fetch new data
    }
  };

  const handleNext = () => {
    if (calendarApi) {
      calendarApi.next();
      updateDateRange(); // Fetch new data
    }
  };
  const formatDateLocal = (date) => {
    return new Date(date).toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };
  // ✅ Update Date Range & Fetch API
  const updateDateRange = () => {
    if (!calendarApi) return;

    const view = calendarApi.view;
    const start = view.currentStart;
    const end = view.currentEnd;

    const newStartDate = formatDateLocal(start);
    const newEndDate = formatDateLocal(end);

    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setCalendarTitle(view.title);

    getCalenderData(newStartDate, newEndDate); // API call with formatted dates
  };

  const handleDateDoubleClick = (info) => {
    const now = new Date().getTime();
    const diff = now - lastClickTime;

    if (diff < 400) {
      // ✅ Double-click detected
      const clickedDate = moment(info.date).format("D MMMM YYYY");
      showModal(clickedDate); // <-- call your existing modal function
    }

    lastClickTime = now;
  };

  return (
    <div>
      <div className="button-container">
        <Button
          className="white-bg"
          type="primary"
          icon={
            <img
              src={fitericon}
              alt="filter"
              style={{ width: 16, height: 16 }}
            />
          }
          onClick={() => setIsFilterModalOpen(true)}
        >
          Filter
        </Button>
      </div>

      <div className="calendar-container">
        {/* Header Section */}
        <div className="calendar-header">
          <h2>Calendar</h2>
          <Segmented
            options={["Today", "Week", "Month"]}
            onChange={handleViewChange} // Function to change view
            defaultValue="Week" // Set the default view to "Week"
            className="custom-segmented"
          />
          <div className="calendar-actions">
            <Button type="primary" icon={<PlusOutlined />} onClick={showModal}>
              Add Task
            </Button>
            <span style={{ paddingLeft: "20px" }}>
              <SettingOutlined />{" "}
            </span>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <Tag style={{ padding: "5px" }}>
              Parent 1{" "}
              <span style={{ marginTop: "5px", marginLeft: "5px" }}>
                <div className="color"></div>
              </span>
            </Tag>
            <Tag style={{ padding: "5px" }}>
              Parent 2{" "}
              <span style={{ marginTop: "5px", marginLeft: "5px" }}>
                <div className="color-coparent"></div>
              </span>
            </Tag>
          </div>

          <Button>
            Edit Parenting Schedule <EditOutlined />
          </Button>
        </div>
        <div
          className="calenderhead2"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
            borderBottom: "1px solid #ddd",
          }}
        >
          <div
            className="calenderheadlft"
            style={{ fontSize: "16px", fontWeight: "bold" }}
          >
            {calendarTitle}
          </div>
          <div className="calenderRgt">
            <Button
              className="calenderNext"
              shape="circle"
              icon={<LeftOutlined />}
              onClick={handlePrev}
            />
            <Button
              className="calenderPrev"
              shape="circle"
              icon={<RightOutlined />}
              onClick={handleNext}
            />
          </div>
        </div>

        {/* Calendar Component */}
        <FullCalendar
          timeZone="UTC"
          key={calendarView} // Ensures re-render when view changes
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView={calendarView}
          nowIndicator={true} // ✅ Shows the red current time line
          headerToolbar={false}
          allDaySlot={false}
          dateClick={(info) => handleDateDoubleClick(info)}
          dayHeaderFormat={getDayHeaderFormat()} // Custom format (e.g., "Mon 9")
          ref={(calendar) => {
            if (calendar) setCalendarApi(calendar.getApi());
          }}
          slotLabelFormat={{
            hour: "numeric",
            minute: "2-digit",
            meridiem: "short",
          }}
          eventContent={(eventInfo) => {
            // Format time without the date
            const formattedStart = eventInfo.event.start
              ? moment.utc(eventInfo.event.start).format("hh:mm A") // Example: 08:00 PM
              : "";
            const formattedEnd = eventInfo.event.end
              ? moment.utc(eventInfo.event.end).format("hh:mm A") // Example: 08:05 PM
              : "";

            return (
              <p className="calandarEventContent">
                <b>{eventInfo.event.title}</b> <br />
                <span>
                  {formattedStart} - {formattedEnd}
                </span>
              </p>
            );
          }}
          events={events.map((event) => ({
            ...event,
            backgroundColor: event.type == "task" ? "#F0F7FF" : "#FFEEEF", // ✅ Apply color directly
            borderColor: event.type == "task" ? "#F0F7FF" : "#FFEEEF", // Darker shade for border
          }))}
          eventClick={(eventInfo) => {
            if (eventInfo.event.extendedProps.type === "task") {
              handleTaskClick(eventInfo);
            } else {
              handleEventClick(eventInfo);
            }
          }}
          datesSet={datesSetHandler}
          eventTextColor="#1D2433"
        />
      </div>
      <div></div>
      <div>
        <AddTask
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          defaultDate={preselectedDate}
        />
        <FilterModal
          isFilterModalOpen={isFilterModalOpen}
          closeFilterModal={() => setIsFilterModalOpen(false)}
          applyFilters={applyFilters}
          startDate={startDate}
          endDate={endDate}
          getCalenderData={getCalenderData}
        />
      </div>
      <div>
        <ViewTask
          isOpen={ViewTaskmodalOpen}
          onCancel={() => setViewTaskmodalOpen(false)}
          eventData={selectedEvent}
        />
      </div>
      <div>
        <ViewEvent
          isOpen={ViewEventmodalOpen}
          onCancel={() => setViewEventmodalOpen(false)}
          eventData={selectedEvent}
        />
      </div>
    </div>
  );
};
export default CoParentCalender;
